meedy.controller('meedy.priceListController', ['$scope', '$state', 'applicationModel', 'meedy.priceListModel', 'meedy.availabilityRuleModel',
    '$mdDialog', '$translate', 'meedy.userModel',
    function ($scope, $state, applicationModel, priceListModel, availabilityRuleModel, $mdDialog, $translate, userModel) {

        var listeners = {};

        function setData() {
            $scope.forms = {
                priceList: null
            };
            $scope.availableLengths = availabilityRuleModel.generateAppointmentTimeOptions(null, 5, "min");
            $scope.availablePriceLists = [];
            $scope.groupActive = {};
            $scope.activeSubcategory = {};

            $scope.dataLoadingInProgress = false;
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
        }

        function setListeners() {
            listeners.onFormDirtyChanged = function (newValue, oldValue) {
                if (newValue) {
                    applicationModel.viewDirty = true;
                }
            };

            $scope.bindChange(function () {
                return ($scope.forms.priceList && $scope.forms.priceList.$dirty && $scope.isPhysician);
            }, listeners.onFormDirtyChanged, $scope);


            listeners.onPriceListLoad = function (data) {
                $scope.selectedOffers = {};
                $scope.activeOffers = {};
                $scope.priceList = data.pricelistItems;

                $scope.priceList.forEach(function (priceItem) {
                    $scope.selectedOffers[priceItem.offer.code] = true;
                    $scope.activeOffers[priceItem.offer.code] = priceItem;
                });


                priceListModel.getLocalPriceList().then(function (data) {
                    $scope.availablePriceLists = data.group;
                    //slicing out one of categories as it's internals differs from rest
                    $scope.imagingExaminations = $scope.availablePriceLists.splice(3,1)[0];

                    _.forEach($scope.availablePriceLists, function (group) {
                        group.options = _.map(group.options, function (offer) {
                            return {
                                customAppointmentLength: ($scope.activeOffers[offer.code]) ? $scope.activeOffers[offer.code].customAppointmentLength : offer.time,
                                price: ($scope.activeOffers[offer.code]) ? $scope.activeOffers[offer.code].price : offer.price,
                                offer: ($scope.activeOffers[offer.code]) ? $scope.activeOffers[offer.code].offer : offer,
                                selected: !!$scope.selectedOffers[offer.code],
                                id: $scope.activeOffers[offer.code] ? $scope.activeOffers[offer.code].id : null
                            }
                        })
                    });

                    _.forEach($scope.imagingExaminations.options, function(subCategory) {
                        subCategory.options = _.map(subCategory.options, function (offer) {
                            return  {
                                customAppointmentLength: ($scope.activeOffers[offer.code]) ? $scope.activeOffers[offer.code].customAppointmentLength : offer.time,
                                price: ($scope.activeOffers[offer.code]) ? $scope.activeOffers[offer.code].price : offer.price,
                                offer: ($scope.activeOffers[offer.code]) ? $scope.activeOffers[offer.code].offer : offer,
                                selected: !!$scope.selectedOffers[offer.code],
                                id: $scope.activeOffers[offer.code] ? $scope.activeOffers[offer.code].id : null
                            }
                        })
                    });

                    $scope.dataLoadingInProgress = false;
                })
            }
        }

        function setActions() {
            $scope.updateOfferPriceList = function () {
                $scope.forms.priceList.$setSubmitted();

                if($scope.forms.priceList.$valid) {
                    var confirm = $mdDialog.confirm({
                        textContent: $translate.instant('T.MEEDY.MODULE.PRICE_LIST.PRICE_LIST_CHANGES_CONFIRMATION'),
                        ok: $translate.instant('T.MEEDY.MODULE.PRICE_LIST.CONFIRM_CONTINUE'),
                        cancel: $translate.instant('T.MEEDY.UI.APPLICATION.CANCEL')
                    });
                    $mdDialog.show(confirm).then(function () {
                        $scope.savingInProgress = true;

                        $scope.priceList = [];
                        _.forEach(angular.copy($scope.availablePriceLists), function (group) {
                            _.forEach(group.options, function (offer) {
                                if(offer.selected) {
                                    delete offer.selected;
                                    delete offer.offer.price;
                                    delete offer.offer.time;
                                    delete offer.offer.age;
                                    if(offer.id === null) {
                                        delete offer.id;
                                    }
                                    $scope.priceList.push(offer);
                                }
                            })
                        });

                        _.forEach(angular.copy($scope.imagingExaminations.options), function(subCategory) {
                            _.forEach(subCategory.options, function (offer) {
                                if(offer.selected) {
                                    delete offer.selected;
                                    delete offer.offer.price;
                                    delete offer.offer.time;
                                    if(offer.id === null) {
                                        delete offer.id;
                                    }   
                                    $scope.priceList.push(offer);
                                }
                            })
                        });

                        priceListModel.saveMedicalPostPricelist({ pricelistItems: $scope.priceList }).then(function (data) {
                            listeners.onPriceListLoad(data);
                            $scope.savingInProgress = false;
                            $scope.forms.priceList.$setPristine();
                            applicationModel.viewDirty = false;
                        })
                    }, function () {

                    });
                }

            };

            $scope.checkChange = function (price) {
                if(!price.selected) {
                    delete price.price;
                    delete price.customAppointmentLength;
                }
            }

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.PRICE_LIST);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            priceListModel.getPriceListForMedicalPost().then(listeners.onPriceListLoad);
            $scope.dataLoadingInProgress = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
